import { defineMutation, useMutation } from '@pinia/colada';

import { LibraryAPI } from '@/apis';
import { useCsvStore } from '@/stores/csv';
import { useIdentityStore } from '@/stores/identity';
import { useSocketStore } from '@/stores/socket';

export const useGenerateMediaListCSV = defineMutation(() => {
  const identityStore = useIdentityStore();
  const socketStore = useSocketStore();
  const csvStore = useCsvStore();

  const { mutate, isLoading, ...mutation } = useMutation({
    async mutation({ filters, sortFields, sort, source, type, limit, fileNamePrefix }) {
      csvStore.requestCSV({ type });
      const [response] = await Promise.all([
        LibraryAPI.getMediaListCSV({
          source,
          filters,
          sortFields,
          sort,
          brandId: identityStore.currentBrand?.id,
          socketId: socketStore.id,
          limit,
          fileNamePrefix,
        }),
        csvStore.requestCSVAndWait({ type }),
      ]);
      return response?.data;
    },
  });

  return { generateMediaListCSV: mutate, isGeneratingMediaListCSV: isLoading, ...mutation };
});
